import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/components/alertBarStyle';
import alertSVG from 'assets/img/icons/alert.svg';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { BodyM } from 'components/Typography/Typography';

interface IALertsProps {
	description: string;
	action?: React.ReactNode;
}

// @ts-ignore
const useStyles = makeStyles(styles);

const Alerts: React.FC<IALertsProps> = ({ description, action }) => {
	const classes = useStyles();
	return (
		<Paper className={classes.alertBar} elevation={3}>
			<div className={classes.message}>
				<img className={classes.icon} src={alertSVG} alt="" role="presentation" />
				<BodyM disableMargin color="primary-dark">
					{description}
				</BodyM>
			</div>
			{action && <Button className={classes.button}>{action}</Button>}
		</Paper>
	);
};

export default Alerts;
